import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'

import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import { teacher } from '../../store/teacherRep.ts'
import { reportTeacher } from '../../store/reportTeacher'

const TeacherWorkModal = ({ openForm, openSpravka }) => {
	const { t, i18n } = useTranslation()
	const [modalData, setModalData] = useState([])
	const [refusal, setRefusal] = useState(false)
	const [isSave, setIsSave] = useState(false)
	const [updateData, setUpdateData] = useState({
		naznachenie: '',
		naznachenie_kg: '',
	})
	const [reasonRefusal, setReasonRefusal] = useState({
		rejected_komment: ''
	})

	const day_do = new Date().getDay()
	const month_do = new Date().getMonth() + 1;
	const year_do = new Date().getFullYear() 

	const [updateDataDo, setUpdateDataDo] = useState({
		data_po: `${year_do}-${month_do}-${day_do}`,
	})
	console.log('updateDataDo',updateDataDo)

	const change = e => {
		const { name, value } = e.target
		setUpdateData({ ...updateData, [name]: value })
		console.log(':nameval', { [name]: value })
		setIsSave(true)
		console.log('issave', isSave)
	}

	const onChangeDate = e => {
		setUpdateDataDo({
			...updateDataDo,
			[e.target.name]: e.target.name == 'with_honors' ? e.target.checked : e.target.value
		})
		setIsSave(true)
	}

	const changeRefusal = e => {
		const { name, value } = e.target
		setReasonRefusal({ ...reasonRefusal, [name]: value })
		console.log(':reasonRefusal', { [name]: value })
	}

	const getReportsTeacher = async () => {
		const a = await http.post('/report/reportApplicationTeacher?reportType= ' + null)
		reportTeacher.newReportTeacher(a.data.reportApplicationTeacherWait)
	}

	const openInput = () => {
		setRefusal(!refusal)
	}


	useEffect(() => {
		if (openForm) {
			getModaldata()
		}
	}, [])

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata-teacher', {
			id_teacher: teacher.teacher.id_teacher,
			id_working: teacher.teacher.id_working,
			id_zakaz: teacher.teacher.id_okno_zakaz,
			doc: teacher.teacher.id_okno_document
		})
		setModalData(res.data.data)
		setUpdateData({
			naznachenie: res.data.data.naznachenie,
			naznachenie_kg: res.data.data.naznachenie_kg
		})
		setUpdateDataDo({data_po: res.data.data.data_po != null ? dayjs(res.data.data.data_po).format("YYYY-MM-DD"):`${year_do}-${month_do}-${day_do}`})
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'
		return () => (document.body.style.overflowY = 'visible')
	}, [])
	
	const updateModalDate = async () => {
		const data_po = dayjs(updateDataDo.data_po).format('YYYY-MM-DD HH:mm:ss')

		const res = await http.post('/okno/modalDateUpdateTeach', {
			id_zakaz:teacher.teacher.id_okno_zakaz,
			id_teacher:teacher.teacher.id_teacher,
			id_working:teacher.teacher.id_working,
			doc:teacher.teacher.id_okno_document,
			naznachenie: updateData.naznachenie,
			naznachenie_kg: updateData.naznachenie_kg,
            data_po: data_po,
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			setIsSave(false)
		}
	}


	const postReasonRefusal = async () => {
		const res = await http.post('/okno/reasonRefusal', {
			id_zakaz: teacher.teacher.id_okno_zakaz,
			doc: teacher.teacher.id_okno_document,
			rejected_komment: reasonRefusal.rejected_komment
		})
		if (res.data.result == null) {
			toast(res.data.result)
			getReportsTeacher()
			openForm()
		}
	}

	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData?.okno_document}</label>
					{!refusal ? (
						<div className={styles.add_form_stud_exit}>
							{updateData.naznachenie?.length > 6 ? (
								<button className={styles.button_modal}>
										<a
											onClick={openForm}
											className='new_report'
											target='_blank'
											href={`/bt/api/r-t/p-w?idzakaz=${teacher.teacher.id_okno_zakaz}&id_w=${teacher.teacher.id_working}&id_t=${teacher.teacher.id_teacher}&lang=${i18n.language}`}
										>
											{' '}
											Просмотр
										</a>
								</button>
							) : null}
						</div>
					) : (
						<div></div>
					)}
				</div>

				{!refusal ? (
					<div>
						<div className={styles.name_student}>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Сотрудник:</span>
								<p>{modalData?.t_fio}</p>
							</div>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Уникальный номер справки:</span>
								<p>{modalData?.reference_number}</p>
							</div>
						</div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Максаты:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='naznachenie_kg'
									value={updateData.naznachenie_kg}
									onChange={change}
								>
									{/* Назначение */}
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Назначение:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='naznachenie'
									value={updateData.naznachenie}
									onChange={change}
								>
									{/* Назначение */}
								</input>
							</div>


							<div className={styles.input_block}>
								<div className={styles.new_input_block_date}>
									<span className={styles.name_student_text}>Действительна до:</span>
								</div>
								<div className={styles.new_input_block_date2} style={{marginLeft: '30px'}}>
									<input
										onChange={onChangeDate}
										className={styles.input_modal_date}
										type='date'
										placeholder='дата'
										name='data_po'
										value={updateDataDo.data_po}
									/>
									<span className={styles.name_student_text}>чейин жарактуу</span>
								</div>
							</div>
						</div>

						<div className={styles.user}>
							<div className={styles.user_name}>
								<span className={styles.name_student_text}>Исполнитель:</span>
								<p>{modalData?.AVN_operator}</p>
							</div>
						</div>
					</div>
				) : (
					<div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Причина отказа:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='rejected_komment'
									placeholder='Введите причину отказа...'
									value={reasonRefusal.rejected_komment}
									onChange={changeRefusal}
								>
									{/* Причина отказа */}
								</input>
							</div>
						</div>
					</div>
				)}
				<div className={styles.modal_footer}>
					<div></div>
					<div className={styles.footer_buttons}>
						{refusal ? (
							<>
								{reasonRefusal.rejected_komment?.length >= 6 ? (
									<button 
                                    onClick={postReasonRefusal}
                                     className={styles.button_modal}>
										Отказать
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={postReasonRefusal}
									>
										Отказать
									</button>
								)}
								<button onClick={openInput} className={styles.button_modal}>
									Назад
								</button>
							</>
						) : (
							<>
								<button onClick={openInput} className={styles.button_modal}>
									Отказать
								</button>
								{updateData.naznachenie?.length >= 3 && isSave ? (
									<button className={styles.button_modal} 
                                    onClick={updateModalDate}
                                    >
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default TeacherWorkModal
